"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: 2px solid ", ";\n  pointer-events: none;\n  position: absolute;\n  z-index: 2;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var regionStyle = (0, _emotion.css)(_templateObject(), colors.info.base);

var SelectRegion =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SelectRegion, _PureComponent);

  function SelectRegion() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectRegion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectRegion)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildStyles", (0, _memoizeOne.default)(function (left, top, width, height) {
      return {
        height: height + 1,
        left: left,
        top: top,
        width: width + 1
      };
    }));
    return _this;
  }

  (0, _createClass2.default)(SelectRegion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          height = _this$props.height,
          left = _this$props.left,
          top = _this$props.top,
          width = _this$props.width;
      var style = this.buildStyles(left, top, width, height);
      return _react.default.createElement("div", {
        className: regionStyle,
        style: style
      });
    }
  }]);
  return SelectRegion;
}(_react.PureComponent);

exports.default = SelectRegion;
(0, _defineProperty2.default)(SelectRegion, "propTypes", {
  height: _propTypes.default.number.isRequired,
  left: _propTypes.default.number.isRequired,
  top: _propTypes.default.number.isRequired,
  width: _propTypes.default.number.isRequired,
  onExpand: _propTypes.default.func,
  onShift: _propTypes.default.func
});